/// <amd-module name="SuiteCommerce.StockNotifications.Item.Option.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.Item.Option.Collection", ["require", "exports", "Backbone", "SuiteCommerce.StockNotifications.Item.Option.Model"], function (require, exports, Backbone_1, Item_Option_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ItemOptionCollection = void 0;
    var ItemOptionCollection = /** @class */ (function (_super) {
        __extends(ItemOptionCollection, _super);
        function ItemOptionCollection() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ItemOptionCollection.prototype, "model", {
            get: function () {
                return Item_Option_Model_1.ItemOptionModel;
            },
            enumerable: false,
            configurable: true
        });
        return ItemOptionCollection;
    }(Backbone_1.Collection));
    exports.ItemOptionCollection = ItemOptionCollection;
});
